var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6DA544"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M144.696,306.087c0,18.441,14.95,33.391,33.391,33.391h100.174 c0,15.368,12.458,27.826,27.826,27.826h33.391c15.368,0,27.826-12.458,27.826-27.826v-33.391H144.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M370.087,144.696v77.913c0,12.275-9.986,22.261-22.261,22.261v33.391 c30.687,0,55.652-24.966,55.652-55.652v-77.913H370.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M130.783,222.609c0,12.275-9.986,22.261-22.261,22.261v33.391c30.687,0,55.652-24.966,55.652-55.652 v-77.913h-33.391V222.609z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 144.696,
    style: {
      fill: "#F0F0F0"
    },
    width: 33.391,
    height: 77.913
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M269.913,189.217c0,3.069-2.497,5.565-5.565,5.565s-5.565-2.497-5.565-5.565v-44.522h-33.391v44.522 c0,3.069-2.497,5.565-5.565,5.565s-5.565-2.497-5.565-5.565v-44.522H180.87v44.522c0,21.481,17.476,38.957,38.957,38.957 c8.273,0,15.945-2.6,22.261-7.016c6.315,4.415,13.988,7.016,22.261,7.016c1.666,0,3.304-0.117,4.915-0.322 c-2.366,9.749-11.146,17.017-21.611,17.017v33.391c30.687,0,55.652-24.966,55.652-55.652v-33.391v-44.522h-33.391V189.217z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.87,
    y: 244.87,
    style: {
      fill: "#F0F0F0"
    },
    width: 50.087,
    height: 33.391
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSa);
export default __webpack_public_path__ + "static/media/sa.f5f84c51bbab5702a1debc695b2e414a.svg";
export { ForwardRef as ReactComponent };